import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { LeftRail, RightRail, RailCTA, ProgressBar } from 'components';
import config from '../../../config';
import en from '../../../international/translations/en';

class CancelWrapper extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    splash: PropTypes.string.isRequired,
  };

  getSplashClassName = (splash, company) =>
    classNames({
      'cancel-wrapper__splash': true,
      [`cancel-wrapper__splash__${splash}--${company}`]: true,
    });

  render() {
    const { children, splash, cancelStep } = this.props;
    const brand = config.company;
    const copy = {
      ...en.rail_cta,
      ...en.premiumFeatures
    };

    return (
      <div className="cancel-wrapper">
        <div
          className="cancel-wrapper__mobile__header"
        />
        <LeftRail>
          <div className="cancel-wrapper__content">
            <ProgressBar currentStep={cancelStep} totalSteps="4" />
            {children}
          </div>
        </LeftRail>
        <RightRail>
          {splash === 'landing' ? (
            <RailCTA
              copy={copy}
            />
          ) : (
            <div
              className={this.getSplashClassName(splash, brand)}
            />
          )}
        </RightRail>
      </div>
    );
  }
}

export default connect(state => ({
  cancelStep: state.subscription.cancelStep,
}))(CancelWrapper);
